// Domaine du Pourra — comportements du thème (aucune dépendance externe)

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initAgeGate();
  initQtyInputs();
  initCartRemove();
  initCartMultipleCheck();
});

/* ── Menu mobile ─────────────────────────────────────────── */
function initMobileNav() {
  const burger = document.querySelector('[data-nav-burger]');
  const mobile = document.querySelector('[data-nav-mobile]');
  if (!burger || !mobile) return;
  burger.addEventListener('click', () => {
    const open = mobile.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

/* ── Barrière d'âge (18+) ────────────────────────────────────
   Code de thème pur (aucun compte/app requis) : mémorise le choix
   dans le navigateur du visiteur. Peut être désactivée depuis
   Personnaliser le thème > Barrière d'âge. */
const AGE_GATE_KEY = 'pourra_age_ok';

function initAgeGate() {
  const gate = document.querySelector('[data-age-gate]');
  if (!gate) return;

  if (localStorage.getItem(AGE_GATE_KEY) === '1') {
    gate.hidden = true;
    return;
  }

  const yes = gate.querySelector('[data-age-yes]');
  const no = gate.querySelector('[data-age-no]');
  const refusedPanel = gate.querySelector('[data-age-refused]');
  const questionPanel = gate.querySelector('[data-age-question]');

  yes?.addEventListener('click', () => {
    localStorage.setItem(AGE_GATE_KEY, '1');
    gate.hidden = true;
  });
  no?.addEventListener('click', () => {
    if (questionPanel) questionPanel.hidden = true;
    if (refusedPanel) refusedPanel.hidden = false;
  });
}

/* ── Sélecteurs de quantité (fiche produit + panier) ──────────
   Le minimum est configurable via data-qty-min (défaut 1). Sur la
   page panier, data-qty-min="0" est utilisé pour permettre de
   retirer un article en descendant la quantité à zéro. */
function initQtyInputs() {
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    const min = parseInt(wrap.dataset.qtyMin, 10) || 0;
    const floor = wrap.hasAttribute('data-qty-min') ? min : 1;
    minus?.addEventListener('click', () => {
      input.value = Math.max(floor, (parseInt(input.value, 10) || floor) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus?.addEventListener('click', () => {
      input.value = Math.min(120, (parseInt(input.value, 10) || floor) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

/* ── Retirer un article du panier ─────────────────────────────
   Met la quantité de la ligne à 0 puis soumet le formulaire
   panier (équivalent natif à "Mettre à jour" après avoir vidé
   le champ), sans dupliquer de champ de formulaire. */
function initCartRemove() {
  document.querySelectorAll('[data-qty-remove]').forEach((button) => {
    button.addEventListener('click', () => {
      const row = button.closest('.vintage-row');
      const input = row?.querySelector('input[type="number"]');
      const form = button.closest('form');
      if (!input || !form) return;
      input.value = 0;
      form.requestSubmit();
    });
  });
}

/* ── Avertissement "multiple de 3" du panier, en direct ───────
   Recalcule le total dès qu'une quantité change (saisie ou +/-),
   sans attendre le clic sur "Mettre à jour". Le rendu Liquid ne
   sert que d'état initial (fonctionne sans JS, juste pas en direct). */
function initCartMultipleCheck() {
  const inputs = document.querySelectorAll('[data-cart-line-qty]');
  const warning = document.querySelector('[data-cart-warning]');
  const checkoutBtn = document.querySelector('[data-cart-checkout]');
  if (!inputs.length || !warning || !checkoutBtn) return;

  const missingEl = warning.querySelector('[data-cart-warning-missing]');
  const pluralEl = warning.querySelector('[data-cart-warning-plural]');

  const recompute = () => {
    let total = 0;
    inputs.forEach((input) => { total += parseInt(input.value, 10) || 0; });
    const remainder = total % 3;

    if (total > 0 && remainder !== 0) {
      const missing = 3 - remainder;
      if (missingEl) missingEl.textContent = missing;
      if (pluralEl) pluralEl.textContent = missing > 1 ? 's' : '';
      warning.hidden = false;
      checkoutBtn.disabled = true;
    } else {
      warning.hidden = true;
      checkoutBtn.disabled = false;
    }
  };

  inputs.forEach((input) => {
    input.addEventListener('input', recompute);
    input.addEventListener('change', recompute);
  });

  recompute();
}
